import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { hasDelmanDevice } from '@/shared/auth/delmanDeviceStorage'
import { hasDelmanSession } from '@/shared/auth/delmanSessionStorage'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function DelmanGuard({ children }: { children: ReactNode }) {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return <div className="min-h-screen bg-surface" aria-hidden />
  }
  if (!hasDelmanDevice()) {
    return <Navigate to="/delman/activate" replace />
  }
  if (!hasDelmanSession()) {
    return <Navigate to="/delman/login" replace />
  }
  return <>{children}</>
}
